import environments from '../environments';

/**
 * Gets the value of an environment variable.
 * Supports boolean, empty and null.
 *
 * @param {string} key
 * @param {*} value
 */

const env = (key, param = undefined) => {
  const value = environments[key];

  if (param !== undefined) {
    environments[key] = param;
    return param;
  }

  return value;
};

export default env;
